// src/components/CostBarChart.js
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register the components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CostBarChart = ({ chartData, totalActual, totalWhatIf }) => {
  
  const actual = totalActual || 0;
  const whatIf = totalWhatIf || 0;

  const savings = actual - whatIf;
  const savingsText = savings > 0 
    ? `Potential Savings: £${savings.toFixed(4)}`
    : (savings < 0 ? `Potential Loss: £${Math.abs(savings).toFixed(4)}` : 'No Change in Cost');
  
  const titleText = 'Actual Cost vs. Potential "What-If" Cost';
  const subtitleText = `Total Actual: £${actual.toFixed(4)} | Total What-If: £${whatIf.toFixed(4)}`;


  const options = {
    responsive: true,
    maintainAspectRatio: false, // This is key
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: [
          titleText,
          subtitleText,
          savingsText
        ],
        font: {
          size: 16
        },
        padding: {
          bottom: 20
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += `£${context.parsed.y.toFixed(6)}`;
            }
            return label;
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return `£${value.toFixed(2)}`;
          }
        }
      }
    }
  };

  return (
    // +++ THIS IS THE FIX +++
    // We add an outer wrapper div to constrain the chart's container.
    // This forces the chart to respect the boundaries of the flex item.
    <div style={{ width: '100%', marginBottom: '30px' }}> 
      <div style={{ position: 'relative', height: '400px', background: '#f9f9f9', padding: '15px', borderRadius: '8px', border: '1px solid #ccc' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
    // +++ END OF FIX +++
  );
};

export default CostBarChart;